import { render } from "./SideMenuArea.vue?vue&type=template&id=7c5e1b45&scoped=true"
import script from "./SideMenuArea.vue?vue&type=script&lang=js"
export * from "./SideMenuArea.vue?vue&type=script&lang=js"

import "./SideMenuArea.vue?vue&type=style&index=0&id=7c5e1b45&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\xampp\\htdocs\\ui\\2025\\07\\tokyo-shoseki\\r9\\08s_r\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5e1b45"]])

export default __exports__